module.exports = __webpack_public_path__ + "img/Ticket.c8c5ea5f.png";